import React, { useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import ChatHeader from "../../ChatLayout/ChatHeader";
import { FaCircle } from "react-icons/fa";
import ProfileDetails from "../../../UserProfile/ProfileDetails";

const TeamDirectories = ({ directoryName, members, activeChannel, selectedData, onClose, activeSection, setActiveSection }) => {
  const [memberData, setMemberData] = useState(false);

  return (
    <div className="chat-wrapper">
      <div className="chat-main">
        <ChatHeader memberList={members} activeChannel={activeChannel} channelName={directoryName} />
        <Container fluid className="p-3 overflow-auto" style={{height: "calc(100vh - 56px)"}}>
          <Row className="g-3">
            {members.map((member) => (
              <Col key={member.id} xl={(activeSection || selectedData) ? 3 : 2} lg={3} md={6} sm={12}>
                <Card
                  className="h-100 team-card overflow-hidden border"
                  title={`${member.name} ${member?.own && "(You)"})`}
                  onClick={() => {setActiveSection(true); setMemberData(member); onClose()}}
                >
                  <img
                    className=""
                    src={member.icon || "https://password-super.s3.ap-south-1.amazonaws.com/icons/useryellow.png"}
                    alt={member.name}
                    style={{ height: 160 }}
                  />
                  <Card.Body className="p-3">
                    <div
                      className="fw-bold section-title m-0"
                      style={{ fontSize: 12 }}
                    >
                      {member?.name} {member?.own && "(You)"}
                      <div
                        className={
                          member.liveStatus === "online"
                            ? "text-success"
                            : member.liveStatus === "away"
                            ? "text-warning"
                            : "text-secondary small rounded-1"
                        }
                      >
                        <FaCircle style={{ fontSize: 8 }} />
                      </div>
                    </div>
                    <div
                      className="small section-title"
                      style={{ fontSize: 10 }}
                    >
                      {member.designationName}
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
      {activeSection && (
        <ProfileDetails
          statusData={activeSection}
          userId={memberData?.userId}
          onClose={() => setActiveSection(null)}
        />
      )}
    </div>
  );
};

export default TeamDirectories;
